import { createActionName } from "../../../utility"

export const reducerName = "glossaryItems"

export const GLOSSARY_ITEM = createActionName(reducerName, "GLOSSARY_ITEM")
export const GLOSSARY_ITEMS = createActionName(reducerName, "GLOSSARY_ITEMS")
